import React, { useState, useEffect } from "react";
import { Product } from "@apis/index";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import theme from "@utils/theme";
import { Sparkles } from "lucide-react";
import RecommendationModal from "../list/RecommendationModal";
import { useModal } from "@context/ModalContext";
import useConfig from "@hooks/useConfig";

interface RecommendationSectionProps {
  product: any;
}

export const RecommendationSection: React.FC<RecommendationSectionProps> = ({
  product,
}) => {
  const [recommendations, setRecommendations] = useState<any[]>([]);
  const { showModal, hideModal } = useModal();
  const { bucketUrl } = useConfig();

  const fetchRecommendations = async () => {
    if (!product?.id) return;
    try {
      const res: any = await Product.getRecommendations({ id: product.id });
      setRecommendations(res || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (product?.id) {
      fetchRecommendations();
    }
  }, [product]);

  if (!product?.id) return null;

  return (
    <FieldWrapper styleWrapper="width:98%">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <Typography styleText="font-size:18px;font-weight:700">
          Product Recommendations
        </Typography>
        <button
          type="button"
          onClick={() => {
            showModal(
              <RecommendationModal
                product={product}
                visible={true}
                onClose={() => {
                  hideModal();
                  fetchRecommendations();
                }}
              />,
              { width: 1200 },
            );
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 16px",
            backgroundColor: theme.colors.primary,
            color: "#fff",
            fontSize: "14px",
            fontWeight: 500,
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
          }}
        >
          <Sparkles size={16} /> Manage Recommendations
        </button>
      </div>

      {/* Preview Grid */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
        {recommendations.length > 0 ? (
          recommendations.map((item) => (
            <div
              key={item.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                backgroundColor: "#fff",
                minWidth: "180px",
              }}
            >
              <img
                src={
                  item.images?.[0]?.image
                    ? `${bucketUrl}/${item.images[0].image}`
                    : "https://via.placeholder.com/40"
                }
                alt={item.name}
                style={{
                  width: "32px",
                  height: "32px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  backgroundColor: "#f7fafc",
                }}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#2d3748",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "120px",
                  }}
                  title={item.name}
                >
                  {item.name}
                </span>
                <span style={{ fontSize: "11px", color: "#718096" }}>
                  {item.price}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              padding: "20px",
              width: "100%",
              textAlign: "center",
              backgroundColor: "#f9fafb",
              borderRadius: "8px",
              border: "1px dashed #e2e8f0",
              color: "#a0aec0",
              fontSize: "14px",
            }}
          >
            No recommendations added yet. Click "Manage" to add some.
          </div>
        )}
      </div>
    </FieldWrapper>
  );
};
